export class AnnuallyConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "timeOfDay",
            "baseName": "timeOfDay",
            "type": "TimeOfDay",
            "format": ""
        },
        {
            "name": "timeOfYear",
            "baseName": "timeOfYear",
            "type": "TimeOfYear",
            "format": ""
        },
        {
            "name": "startWindowMinutes",
            "baseName": "startWindowMinutes",
            "type": "number",
            "format": "long"
        }
    ];
    static getAttributeTypeMap() {
        return AnnuallyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
